<style scoped>
.ivu-table .demo-table-info-row td {
    color: red;
}

.custom-group-switch-giro {
  padding: 3px 1.9rem 3px 1.9rem;
  border: 1px solid #dddee1;
  background: #f7f7f7;
  margin-right: -2px;
  z-index: 10;
}

/* .custom-group-switch {
    margin-right: -2px;
    z-index: 10;
    border-radius: 0;
}

.custom-group-switch .ivu-switch-large {
    height: 99%;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-top: 4px;
    width: 70px;
}

.custom-group-switch .ivu-switch-inner {
    margin-left: 4px;
}

.custom-group-switch .ivu-switch-large:after {
    margin: 4px 0 0 4px;
} */
</style>

<template>
    <div>
        <Card>
            <p slot="title"> Giro List </p>

            <Button slot="extra" type="primary" @click="showAddGiro" icon="plus-round" size="small">
                <span>Tambah Giro</span>
            </Button>

            <Row type="flex" justify="space-between">
                <Col span="10">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group" style="padding: 0 1.2rem;">Bank Account</Button>
                        <Select
                            v-model="bankAccountId"
                            placeholder="Select"
                            clearable
                            filterable>
                            <Option
                                v-for="bankAccount in bankAccounts"
                                :value="bankAccount.id"
                                :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
                        </Select>
                    </ButtonGroup>
                </Col>
                <Col span="10" style="display: flex; justify-content: center; align-items: center;">
                    <div class="custom-group-switch-giro">
                        <i-switch size="large" v-model="isGroupFilter">
                            <span slot="open">Group</span>
                            <span slot="close">Mark</span>
                        </i-switch>
                    </div>
                    <transition name="move-right">
                        <Select clearable filterable placeholder="Select Marking" v-show="isGroupFilter == false"
                            v-model="markingHeaderIdSelected" :remote-method="getMarkingByCode"
                            :loading="isLoadingGetMarking">
                            <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                {{ option.label }}</Option>
                        </Select>
                    </transition>

                    <transition name="move-left">
                        <Select clearable filterable placeholder="Select Group Name" v-show="isGroupFilter == true"
                            v-model="markingGroupIdSelected" :remote-method="getGroupMarkingByCode"
                            :loading="isLoadingGetMarking">
                            <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                {{ option.label }}</Option>
                        </Select>
                    </transition>
                </Col>

                <Col span="3">
                    <Button type="primary" icon="ios-search" @click="getReceivableGiroList()">
                        <span>Cari</span>
                    </Button>
                </Col>
            </Row>

            <br/>

            <Row type="flex" justify="space-between">
                <Col span="10">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group">Tgl. Terima Giro</Button>
                        <DatePicker v-model="giroDateSelected" type="daterange" placeholder="Select date"
                            style="width: 100%" />
                    </ButtonGroup>
                </Col>
                <Col span="10">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group">Tgl. Jatuh Tempo</Button>
                        <DatePicker v-model="paymentDateSelected" type="daterange" placeholder="Select date"
                            style="width: 100%" />
                    </ButtonGroup>
                </Col>

                <Col span="3">
                    <Spin size="large" v-show="isLoadingGiroList"></Spin>
                </Col>
            </Row>

            <br/>

            <Card>
                <button type="button" @click="generateReport" class="ivu-btn ivu-btn-default ivu-btn-small"
                    style="margin-right: 5px;"> <span>Generate PDF</span></button>
                <button type="button" @click="generateExcel" class="ivu-btn ivu-btn-default ivu-btn-small"
                    style="margin-right: 5px;"> <span>Generate XLSX</span></button>
                <br /><br />

                <Alert type="info" show-icon v-show="totalGiro != 0"> Total Giro = {{ totalGiro }} lembar</Alert>
                <Alert type="success" show-icon v-show="totalGiro != 0"> Total Nominal = Rp {{ totalNominal |
                    numberFormatted }}</Alert>
                <Alert type="warning" show-icon v-show="totalGiro != 0"> Klik Mutasi untuk Generate NT pada Mutasi</Alert>
                <Table :row-class-name="rowClassName" :columns="columnsDataTable" :data="receivableGiroData"></Table>
            </Card>
        </Card>

        <!-- Modal add giro - old -->
        <!-- <Modal v-model="isModalAddGiro" width="500px">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Giro</span>
            </p>
            <Form ref="formAddGiro" :model="formAddGiro" :rules="ruleValidateGiro">
                <Form-item>
                    <Row>
                        <Col span="12">
                        <i-switch size="large" v-model="isGroupAdd">
                            <span slot="open">Group</span>
                            <span slot="close">Mark</span>
                        </i-switch>
                        </Col>
                        <Col span="11" offset="1">
                        <transition name="move-up">
                            <Select filterable placeholder="Ketik Marking" v-show="isGroupAdd == false"
                                v-model="formAddGiro.markingHeaderId" :remote-method="getMarkingByCode"
                                :loading="isLoadingGetMarking" @on-change="isForm = true">
                                <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                    {{ option.label }}</Option>
                            </Select>
                        </transition>

                        <transition name="move-down">
                            <Select filterable placeholder="Ketik Group Name" v-show="isGroupAdd == true"
                                v-model="formAddGiro.markingGroupId" :remote-method="getGroupMarkingByCode"
                                :loading="isLoadingGetMarking" @on-change="isForm = true">
                                <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                    {{ option.label }}</Option>
                            </Select>
                        </transition>
                        </Col>
                    </Row>
                </Form-item>
                <div v-show="isForm">
                    <Form-item label="Tanggal Terima Giro" prop="giroDate">
                        <Date-picker placeholder="Tanggal Terima Giro" style="width: 200px;display:revert;" type="date"
                            format="yyyy-MM-dd" v-model="formAddGiro.giroDate">
                        </Date-picker>
                    </Form-item>
                    <Form-item label="Nomor Giro" prop="giroNumber">
                        <Input v-model="formAddGiro.giroNumber" placeholder="Nomor Giro"></Input>
                    </Form-item>
                    <Form-item label="Nominal Giro" prop="giroNominal">
                        <br />
                        <money v-model="formAddGiro.giroNominal" v-bind="money" class="ivu-input"></money>
                    </Form-item>
                    <Form-item label="Tanggal Jatuh Tempo" prop="paymentDate">
                        <Date-picker placeholder="Tanggal Jatuh Tempo" style="width: 200px;display:revert;" type="date"
                            format="yyyy-MM-dd" v-model="formAddGiro.paymentDate">
                        </Date-picker>
                    </Form-item>
                    <Form-item label="Bank" prop="bankAccountId">
                        <br>
                        <Select style="width:80%;display:revert" placeholder="Pilih Rekening Bank" clearable filterable
                            v-model="formAddGiro.bankAccountId">
                            <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                                bankAccount.accountName }}
                            </Option>
                        </Select>
                    </Form-item>
                    <Form-item label="Upload File" prop="file">
                        <br>
                        <img v-show="formAddGiro.imageUploaded" :src="formAddGiro.imageUploaded" alt="Uploaded Image"
                            style="width: 100%; height: auto;" />
                        <Input style="display: none;" v-model="formAddGiro.markingHeaderCode"></Input>
                        <Upload type="drag" ref="upload" name="fileUploaded" :action="this.serverUrlUploadFile"
                            :before-upload="handleBeforeUpload">
                            <div style="padding: 20px 0">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>Click or drag files here to upload</p>
                            </div>
                        </Upload>
                        <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                    </Form-item>
                </div>
            </Form>
            <div slot="footer">
                <Button v-show="true" type="primary" :loading="isLoadingAddGiro" @click="postAddGiro">
                    <span v-if="!isLoadingAddGiro">Submit</span>
                    <span v-else>On process.....</span>
                </Button>
            </div>
        </Modal> -->

        <!-- Modal add giro -->
        <Modal v-model="isModalAddGiro" width="90%">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Giro List</span>
            </p>

            <Form ref="formAddGiro" :model="formAddGiro" :rules="ruleValidateGiro">
                <Card>
                    <Form-item style="margin-bottom: 0px;">
                          <Row type="flex" justify="space-between">
                              <Col span="4">
                                  <Date-picker
                                      placeholder="Tanggal Terima Giro"
                                      type="date"
                                      format="yyyy-MM-dd"
                                      v-model="formAddGiro.giroDate"
                                      @on-change="isHeaderFilled">
                                  </Date-picker>
                              </Col>
                              <Col span="12">
                                  <Select placeholder="Pilih Rekening Bank" clearable filterable
                                      v-model="formAddGiro.bankAccountId" @on-change="isHeaderFilled">
                                      <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                                          bankAccount.accountName }}
                                      </Option>
                                  </Select>
                              </Col>
                              <Col span="2" style="text-align: right;">
                                  <i-switch size="large" v-model="isGroupAdd">
                                      <span slot="open">Group</span>
                                      <span slot="close">Mark</span>
                                  </i-switch>
                              </Col>
                              <Col span="5">
                                  <transition name="move-up">
                                      <Select filterable placeholder="Ketik Marking" v-show="isGroupAdd == false"
                                          v-model="formAddGiro.markingHeaderId" :remote-method="getMarkingByCode"
                                          :loading="isLoadingGetMarking" @on-change="isHeaderFilled">
                                          <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                              {{ option.label }}</Option>
                                      </Select>
                                  </transition>

                                  <transition name="move-down">
                                      <Select filterable placeholder="Ketik Group Name" v-show="isGroupAdd == true"
                                          v-model="formAddGiro.markingGroupId" :remote-method="getGroupMarkingByCode"
                                          :loading="isLoadingGetMarking" @on-change="isHeaderFilled">
                                          <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                              {{ option.label }}</Option>
                                      </Select>
                                  </transition>
                              </Col>
                              <!-- <Col span="5">
                                  <Select filterable placeholder="Ketik NT Giro" v-show="isGroupAdd == false"
                                      v-model="formAddGiro.noteCode" :remote-method="getGiroCode" clearable
                                      :loading="isLoadingGetMarking">
                                      <Option v-for="option in noteCodes" :value="option.value" :key="option.value">
                                          {{ option.label }}</Option>
                                  </Select>
                              </Col> -->
                          </Row>

                    </Form-item>
                </Card>

                <br>

                <Card v-show="isDetailForm">
                    <p slot="title"> Detail Giro(s) </p>

                    <Button @click="handleAdd" slot="extra" type="info" icon="plus-round" size="small">
                        <span>Tambah Giro</span>
                    </Button>

                    <FormItem>
                        <Row type="flex" justify="space-between">
                            <Col span="5"> Nomor atau Keterangan Giro </Col>
                            <Col span="5"> Nominal Giro </Col>
                            <Col span="5"> Tgl. Jatuh Tempo </Col>
                            <Col span="6"> File(s) </Col>
                            <Col span="2"></Col>
                        </Row>
                    </FormItem>
                    <template v-for="(item, index) in formAddGiro.formDynamic.items">
                        <FormItem v-if="item.status" :key="index">
                            <Row type="flex" justify="space-between">
                                <Col span="5">
                                    <Input v-model="formAddGiro.formDynamic.items[index].giroNumber" placeholder="Nomor Giro"></Input>
                                </Col>
                                <Col span="5">
                                    <money v-model="formAddGiro.formDynamic.items[index].giroNominal" v-bind="money" class="ivu-input"></money>
                                </Col>
                                <Col span="5">
                                    <Date-picker placeholder="Tanggal Jatuh Tempo" type="date" style="width:100%"
                                        format="yyyy-MM-dd" v-model="formAddGiro.formDynamic.items[index].paymentDate">
                                    </Date-picker>
                                </Col>
                                <Col span="6">
                                    <!-- <img v-show="formAddGiro.formDynamic.items[index].imageUploaded" :src="formAddGiro.formDynamic.items[index].imageUploaded" alt="Uploaded Image"
                                        style="width: 100%; height: auto;" /> -->
                                    <!-- <Input style="display: none;" v-model="formAddGiro.formDynamic.items[index].markingHeaderCode"></Input> -->
                                    <Input style="display: none;" v-model="formAddGiro.formDynamic.items[index].imageUploaded"></Input>
                                    <Upload type="drag" ref="upload" name="fileUploaded" :action="serverUrlUploadFile"
                                        :before-upload="(file) => handleBeforeUpload(file, index)">
                                        <div class="custom-upload">
                                            <Icon type="ios-cloud-upload" size="20" style="color: #3399ff"></Icon>
                                            <p>Click or drag files here to upload</p>
                                        </div>
                                    </Upload>
                                    <div @click="handleDownload(index)" class="custom-text-uploaded">{{ formAddGiro.formDynamic.items[index].imageUploaded }}</div>
                                    <Progress :percent="formAddGiro.formDynamic.items[index].pValue" :stroke-width="5" v-show="formAddGiro.formDynamic.items[index].isProgress" style="top: -1rem;" />
                                </Col>
                                <Col span="2">
                                    <Button @click="handleRemove(index)" type="error" style="width:100%;">Delete</Button>
                                </Col>
                            </Row>
                        </FormItem>
                    </template>

                    <FormItem v-show="totalGiroNominal" style="margin: -15px 0">
                        <hr>
                        <Row>
                            <Col span="5" style="display: flex; justify-content: space-between; padding: 10px 0;">
                                <b> Total Giro :  </b>
                                <b> Rp. {{ totalGiroNominal | currency }} </b>
                            </Col>
                            <Col span="18"></Col>
                        </Row>
                    </FormItem>
              </Card>
            </Form>
          <div slot="footer">
            <Button v-show="isDetailForm" type="primary" :loading="isLoadingAddGiro" @click="postAddGiro">
              <span v-if="!isLoadingAddGiro">Submit</span>
              <span v-else>On process.....</span>
            </Button>
          </div>
        </Modal>

        <!-- Modal show history -->
        <Modal v-model="isModalHistory" title="History" width="720px">
            <Table :columns="columnsHistory" :data="dataHistory"></Table>
        </Modal>

        <!-- Modal show detail -->
        <Modal v-model="isModalDetail" title="Detail(s)" width="90%">
            <Table :columns="columnsDetail" :data="dataDetail"></Table>
            <br><hr>

            <div style="margin: 1rem 0 0; font-weight: bold; display: flex; justify-content: space-between; align-items: center; padding-right: 2.5rem;">
                <div>
                    <Select style="width:500px;" placeholder="Pilih Rekening Bank" searchable filterable
                        v-model="formDetailGiro.bankAccountId">
                        <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                            bankAccount.accountName }}
                        </Option>
                    </Select>
                </div>
                <div> Total Giro : {{ totalGiroNominalDetail }} </div>
                <Button type="error" @click="showModalConfirmDetail(dataDetail)">
                  <Icon type="refresh" style="padding-right: 0.5rem;"></Icon>
                  <Span> Batalkan Semua </Span>
                </Button>
            </div>
            <!-- FOOTER CUSTOM -->
            <div slot="footer" style="display:flex; justify-content:flex-end; gap:8px;">
              <Button @click="isModalDetail = false">
                Batal
              </Button>

              <Button
                type="primary"
                @click="updateDetailData"
              >
                Update
              </Button>
            </div>
        </Modal>

        <!-- Modal confirm update list -->
        <Modal v-model="isModalConfirm" title="Konfirmasi" @on-cancel="cancelUpdateGiroList">
            <p>{{ confirmationMessage }}</p>
            <br />
            <div v-show="isNeedConfirm">
                <i> Tambah keterangan untuk melanjutkan ! (minimal 5 karakter)</i>
                <Input v-model="confirmDescription" placeholder="notes" />
            </div>

            <div slot="footer" v-if="isNeedConfirm">
                <Button type="error" long @click="updateGiroList" v-show="confirmDescription.length >= 5">Ya</Button>
            </div>
            <div slot="footer" v-else>
                <Button type="text" @click="cancelUpdateGiroList">Tidak</Button>
                <Button type="primary" @click="updateGiroList">Ya</Button>
            </div>
        </Modal>

        <!-- Modal confirm update detail -->
        <Modal v-model="isModalConfirmDetail" title="Konfirmasi" @on-cancel="cancelUpdateGiroDetail">
            <p> Apakah anda yakin ingin membatalkan giro ? </p>
            <br />
            <div v-show="isNeedConfirmDetail">
                <i> Tambah keterangan untuk melanjutkan ! (minimal 5 karakter)</i>
                <Input v-model="confirmDescriptionDetail" placeholder="notes" />
            </div>

            <div slot="footer" v-if="isNeedConfirmDetail">
                <Button type="error" long @click="updateGiroDetail" v-show="confirmDescriptionDetail.length >= 5">Ya</Button>
            </div>
        </Modal>

        <!-- Modal edit giro -->
        <Modal v-model="isModalEdit" width="500px">
            <p slot="header" style="color:#2cb7f5;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Edit Giro</span>
            </p>
            <Form ref="formEditGiro" :model="formEditGiro" :rules="ruleValidateGiro">
                <Form-item>
                    <Row>
                        <Col span="6">
                        <i-switch size="large" v-model="isGroupEdit">
                            <span slot="open">Group</span>
                            <span slot="close">Mark</span>
                        </i-switch>
                        </Col>
                        <Col span="17" offset="1">
                        <transition name="move-up">
                            <Select filterable placeholder="Ketik Marking" v-show="isGroupEdit == false"
                                v-model="formEditGiro.markingHeaderId" :remote-method="getMarkingByCode"
                                :loading="isLoadingGetMarking">
                                <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                    {{ option.label }}</Option>
                            </Select>
                        </transition>

                        <transition name="move-down">
                            <Select filterable placeholder="Ketik Group Name" v-show="isGroupEdit == true"
                                v-model="formEditGiro.markingGroupId" :remote-method="getGroupMarkingByCode"
                                :loading="isLoadingGetMarking">
                                <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                    {{ option.label }}</Option>
                            </Select>
                        </transition>
                        </Col>
                    </Row>
                </Form-item>
                <Form-item label="Tanggal Terima Giro" prop="giroDate">
                    <Date-picker placeholder="Tanggal Terima Giro" style="width: 200px;display:revert;" type="date"
                        format="yyyy-MM-dd" v-model="formEditGiro.giroDate">
                    </Date-picker>
                </Form-item>
                <Form-item label="Nomor Giro" prop="giroNumber">
                    <Input v-model="formEditGiro.giroId" style="display: none;"></Input>
                    <Input v-model="formEditGiro.giroNumber" placeholder="Nomor Giro"></Input>
                </Form-item>
                <Form-item label="Nominal Giro" prop="giroNominal">
                    <br />
                    <money v-model="formEditGiro.giroNominal" v-bind="money" class="ivu-input"></money>
                </Form-item>
                <Form-item label="Tanggal Jatuh Tempo" prop="paymentDate">
                    <Date-picker placeholder="Tanggal Jatuh Tempo" style="width: 200px;display:revert;" type="date"
                        format="yyyy-MM-dd" v-model="formEditGiro.paymentDate">
                    </Date-picker>
                </Form-item>
                <Form-item label="Bank" prop="bankAccountId">
                    <br>
                    <Select style="width:80%;display:revert" placeholder="Pilih Rekening Bank" clearable
                        v-model="formEditGiro.bankAccountId">
                        <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                            bankAccount.accountName }}
                        </Option>
                    </Select>
                </Form-item>
                <Form-item label="Upload File" prop="file">
                    <br>
                    <img v-show="formEditGiro.imageUploaded" :src="formEditGiro.imageUploaded" alt="Uploaded Image"
                        style="width: 100%; height: auto;" />
                    <Input style="display: none;" v-model="formEditGiro.markingHeaderCode"></Input>
                    <Upload type="drag" ref="upload" name="fileUploaded" :action="this.serverUrlUploadFile"
                        :before-upload="handleBeforeUpload">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                </Form-item>
            </Form>
            <div slot="footer">
                <Button v-show="true" type="primary" :loading="isLoadingEditdGiro" @click="postUpdateGiro">
                    <span v-if="!isLoadingEditdGiro">Submit</span>
                    <span v-else>On process.....</span>
                </Button>
            </div>
        </Modal>

         <!-- Modal edit giro -->
        <Modal v-model="isModalRefGiro" width="500px">
            <p slot="header" style="color:#2cb7f5;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Ref Giro</span>
            </p>
            <Form ref="formRefGiro" :model="formEditGiro" :rules="ruleValidateGiro">
                <Form-item label="NT Giro Lama" prop="giroNumber">
                    <Input v-model="formRefGiro.giroId" style="display: none;"></Input>
                    <Select filterable placeholder="Ketik NT Giro" v-show="isGroupAdd == false"
                        v-model="formRefGiro.giroNumber" :remote-method="getGiroCode" clearable
                        :loading="isLoadingGetMarking">
                        <Option v-for="option in noteCodes" :value="option.value" :key="option.value">
                            {{ option.label }}</Option>
                    </Select>
                </Form-item>
            </Form>
            <div slot="footer">
                <Button v-show="true" type="primary" :loading="isLoadingEditdGiro" @click="postUpdateRefGiro">
                    <span v-if="!isLoadingEditdGiro">Submit</span>
                    <span v-else>On process.....</span>
                </Button>
            </div>
        </Modal>


        <!-- Modal delete payment -->
        <Modal v-model="isModalDelete" title="Konfirmasi" ok-text="Ya" cancel-text="Tidak"
            @on-cancel="confirmDescription = ''">
            <p>Apakah anda yakin ingin menghapus pembayaran giro?</p>
            <br />
            <div>
                <i> Ketik <b>{{ formDeleteGiro.noteCode }}</b> untuk melanjutkan !</i>
                <Input v-model="formDeleteGiro.giroId" style="display: none;"></Input>
                <Input v-model="formDeleteGiro.paymentId" style="display: none;"></Input>
                <Input v-model="confirmDescription" />
            </div>

            <div slot="footer">
                <Button type="error" long
                    v-show="(formDeleteGiro.noteCode).toUpperCase() == confirmDescription.toUpperCase()"
                    @click="deleteGiroPayment">Hapus</Button>
            </div>
        </Modal>

        <!-- Generate PDF -->
        <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
            :paginate-elements-by-height="1400" :pdf-quality="2" :manual-pagination="true"
            :html-to-pdf-options=this.htmlPdfOption pdf-content-width="100%" ref="html2Pdf">
            <section slot="pdf-content">
                <div class="container">
                    <div class="table">
                        <div class="table-header">
                            <div class="header__item">Marking</div>
                            <div class="header__item">Marking Group</div>
                            <div class="header__item">Tgl. Terima Giro</div>
                            <div class="header__item">Tgl. Jatuh Tempo</div>
                            <div class="header__item">Nomor Giro</div>
                            <div class="header__item">Nominal Giro</div>
                            <div class="header__item bank-header">Bank</div>
                            <div class="header__item">Tgl. Mundur</div>
                            <div class="header__item">Kliring</div>
                            <div class="header__item">Keterangan Tgl. Mundu</div>
                            <div class="header__item">Keterangan Pembatalan</div>
                        </div>
                        <div class="table-content">
                            <section class="pdf-item" v-for="(value, index) in receivableGiroData">

                                <div class="table-row pdf-item"
                                    :class="{ 'html2pdf__page-break page-break': (index + 1) % 12 === 0 }">
                                    <div class="table-data">{{ value.marking }}</div>
                                    <div class="table-data">{{ value.markingGroup }}</div>
                                    <div class="table-data">{{ value.giroDate }}</div>
                                    <div class="table-data">{{ value.paymentDate }}</div>
                                    <div class="table-data">{{ value.giroNumber }}</div>
                                    <div class="table-data">{{ value.giroNominal }}</div>
                                    <div class="table-data bank-body">{{ value.accountName }}</div>
                                    <div class="table-data">{{ value.dueDate }}</div>
                                    <div class="table-data">{{ value.isClearing ? 'Ya' : 'Tidak' }}</div>
                                    <div class="table-data">{{ value.dueNotes }}</div>
                                    <div class="table-data">{{ value.cancelNotes }}</div>
                                </div>

                                <div class="table-header"
                                    v-if="(index + 1) % 12 === 0 && receivableGiroData.length !== index + 1">
                                    <div class="header__item">Marking</div>
                                    <div class="header__item">Marking Group</div>
                                    <div class="header__item">Tgl. Terima Giro</div>
                                    <div class="header__item">Tgl. Jatuh Tempo</div>
                                    <div class="header__item">Nomor Giro</div>
                                    <div class="header__item">Nominal Giro</div>
                                    <div class="header__item bank-header">Bank</div>
                                    <div class="header__item">Tgl. Mundur</div>
                                    <div class="header__item">Kliring</div>
                                    <div class="header__item">Keterangan Tgl. Mundu</div>
                                    <div class="header__item">Keterangan Pembatalan</div>
                                </div>

                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </vue-html2pdf>

        <!-- Modal mutasi -->
        <Modal v-model="isModalMutasi" width="500px" @on-cancel="cancelAddMutasi">
            <p slot="header" style="color:#2cb7f5;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Giro - Generate Mutasi</span>
            </p>
            <Form ref="formMutasi" :model="formMutasi">
                <Form-item>
                    <Row>
                        <Col span="6">
                            <i-switch size="large" v-model="isGroupMutasi" :disabled="true">
                                <span slot="open">Group</span>
                                <span slot="close">Mark</span>
                            </i-switch>
                        </Col>
                        <Col span="17" offset="1">
                            <transition name="move-up">
                                <Select filterable placeholder="Ketik Marking" v-show="isGroupMutasi == false"
                                    v-model="formMutasi.markingHeaderId" :remote-method="getMarkingByCode"
                                    :loading="isLoadingGetMarking" :disabled="true">
                                    <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                        {{ option.label }}</Option>
                                </Select>
                            </transition>

                            <transition name="move-down">
                                <Select filterable placeholder="Ketik Group Name" v-show="isGroupMutasi == true"
                                    v-model="formMutasi.markingGroupId" :remote-method="getGroupMarkingByCode"
                                    :loading="isLoadingGetMarking" :disabled="true">
                                    <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                        {{ option.label }}</Option>
                                </Select>
                            </transition>
                        </Col>
                    </Row>
                </Form-item>
                <Form-item label="Tanggal Jatuh Tempo" prop="dueDate">
                    <Date-picker placeholder="Tanggal Jatuh Tempo" style="width: 200px;display:revert;" type="date"
                        format="yyyy-MM-dd" v-model="formMutasi.dueDate" :disabled="true">
                    </Date-picker>
                </Form-item>
                <Form-item label="Tanggal Cair" prop="paymentDate">
                    <Date-picker placeholder="Tanggal Cair" style="width: 200px;display:revert;" type="date"
                        format="yyyy-MM-dd" v-model="formMutasi.paymentDate">
                    </Date-picker>
                </Form-item>
                <Form-item label="Bank" prop="bankAccountId">
                    <br>
                    <Select style="width:80%;display:revert" placeholder="Pilih Rekening Bank" clearable
                        v-model="formMutasi.bankAccountId" :disabled="true">
                        <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                            bankAccount.accountName }}
                        </Option>
                    </Select>
                </Form-item>
                <Form-item label="Kode Nota" prop="noteCode">
                    <Input v-model="formMutasi.noteCode" :disabled="true"></Input>
                </Form-item>
                <Form-item label="Nominal Giro" prop="giroNominal">
                    <money v-model="formMutasi.giroNominal" v-bind="money" class="ivu-input" :disabled="true"></money>
                </Form-item>
                <Form-item label="Keterangan" prop="descriptionMutasi">
                    <Input v-model="formMutasi.descriptionMutasi" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></Input>
                </Form-item>
            </Form>
            <div slot="footer">
                <Button v-show="true" type="primary" :loading="isLoadingMutasi" @click="postAddMutasi">
                    <span v-if="!isLoadingMutasi">Submit</span>
                    <span v-else>On process.....</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<style scoped>
:root {
    --color-alpha: #1772FF;
    --color-form-highlight: #495060;
}

*,
*:before,
*:after {
    box-sizing: border-box;
}

.container {
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: center;
    min-height: 100vh;
    background-color: white;
}

.page-break {
    margin-bottom: 10px;
}

.table {
    width: 100%;
}

.table-header {
    display: flex;
    width: 100%;

    .bank-header {
        flex: 1 1 40%;
    }
}

.table-row {
    display: flex;
    width: 100%;

    .bank-body {
        flex: 1 1 40%;
    }
}

.table-data,
.header__item {
    flex: 1 1 20%;
    text-align: center;
    border: 0.5px solid var(--color-form-highlight);
}

.header__item {
    text-transform: uppercase;
    line-height: 200%;
    font-weight: 500;
}

.custom-upload {
  height: 30px;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.custom-edit-upload {
  padding: 6px 8px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 12px;
  color: #64748b;
  cursor: pointer;
  transition: all .2s ease;
}

.custom-edit-upload:hover {
  border-color: #3399ff;
  background: #eef5ff;
  color: #1d4ed8;
}

.ivu-table a.table-link {
  color: #1890ff !important;
}



.ivu-progress-show-info .ivu-progress-outer {
    padding-left: 2px;
    padding-right: 15px;
    margin-right: -20px;
}
.custom-text-uploaded {
    color: #2e8df1;
    cursor: pointer;
    display: flex;
    justify-content: center;
}
</style>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import { Money } from 'v-money'
import VueHtml2pdf from 'vue-html2pdf'
import * as XLSX from 'xlsx'

const numeral = require('numeral');

export default {
    components: {
        Money,
        VueHtml2pdf
    },
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            bankAccountId: '',
            giroDateSelected: [],
            paymentDateSelected: [],
            noteCodes: [],
            markingGroupIdSelected: null,
            markingHeaderIdSelected: null,
            isGroupFilter: false,
            isLoadingGiroList: false,
            loadingUpdate : false,
            columnsDataTable: [
                {
                    title: 'Marking',
                    key: 'marking',
                    width: 150,
                },
                {
                    title: 'Marking Grup',
                    key: 'markingGroup',
                    width: 150,
                },
                {
                    title: 'Tgl. Terima Giro',
                    key: 'giroDate',
                    width: 150,
                },
                {
                    title: 'Tgl. Jatuh Tempo',
                    key: 'paymentDate',
                    width: 150,
                    type: 'html',
                },
                {
                    title: 'Nomor Giro',
                    key: 'giroNumber',
                    width: 200,
                    type: 'html',
                },
                {
                    title: 'Kode Nota',
                    key: 'noteCode',
                    width: 200,
                },
                {
                    title: 'Nominal Giro',
                    key: 'giroNominal',
                    width: 150,
                },
                {
                    title: 'Bank',
                    key: 'accountName',
                    width: 300,
                },
                // {
                //     title: 'File',
                //     key: 'file',
                //     align: 'center',
                //     width: 250,
                //     render: (h, params) => {
                //         const { row } = params

                //         return h('div', [
                //             h('a', {
                //                 style: {
                //                     textDecoration: 'underline'
                //                 },
                //                 on: {
                //                     click: () => {
                //                         this.downloadFile(row.markingHeaderCode, row.file)
                //                     }
                //                 }
                //             }, row.file)
                //         ]);
                //     }
                // },
                {
                    title: 'Tgl. Mundur',
                    key: 'dueDate',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let setDisable = row.isCancel == 1 ? true : false

                        return h('DatePicker', {
                            props: {
                                type: 'date',
                                value: row.dueDate,
                                disabled: setDisable
                            },
                            on: {
                                'on-change': (date) => {
                                    setDisable ? false : this.showModalConfirm('isDueDate', date, params.index)
                                }
                            }
                        });
                    }
                },
                {
                    title: 'Kliring',
                    key: 'isClearing',
                    width: 80,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let setVal = row.isClearing == 1 ? true : false
                        let setDisable = row.isCancel == 1 ? true : false

                        return h('Checkbox', {
                            props: {
                                value: setVal,
                                checked: setVal,
                                disabled: setDisable
                            },
                            on: {
                                'on-change': (isClearing) => {
                                    this.showModalConfirm('isClearing', isClearing, params.index)
                                }
                            }
                        });
                    }
                },
                {
                    title: 'Ref Giro NT',
                    key: 'refGiroCode',
                    width: 150,
                },
                // {
                //     title: 'Keterangan Tgl. Mundur',
                //     key: 'dueNotes',
                //     width: 200,
                // },
                // {
                //     title: 'Keterangan Pembatalan',
                //     key: 'cancelNotes',
                //     width: 200,
                // },
                {
                    title: ' ',
                    key: 'isCancel',
                    width: 500,
                    align: 'right',
                    fixed: 'right',
                    render: (h, params) => {
                        const { row } = params
                        let setDisable = row.isCancel == 1 ? true : false
                        let setDisableHistory = (row.giroHistory == undefined || row.giroHistory.length > 0) ? false : true
                        let setDisableEdit = (row.paymentId != null || row.isCancel == 1) ? true : false
                        let setDisablePayment = row.paymentId != null ? true : false
                        let setDisableButton = setDisable
                        // let setDisableDetail = (row.giroDetail == undefined || row.giroDetail.length > 0) ? false : true
                        const setDisableMutasi = row.isMutation == 1 ? true : false

                        let type = 'success';
                        let title = 'Bayar'

                        if (setDisablePayment) {
                            type = 'error'
                            title = 'Hapus'
                        }

                        // Handle unclearing as hapus payment terlebih dahulu sebelum dibatalkan
                        if (row.isClearing == 1 || setDisablePayment == true) {
                            setDisable = true
                        }

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: type,
                                    size: 'small',
                                    disabled: setDisableButton

                                },
                                style: {
                                    marginRight: '5px',
                                    width: '70px'
                                },
                                on: {
                                    click: () => {
                                        console.log({ row });
                                        let isGroup = row.markingGroupId ? true : false;
                                        if (setDisablePayment) {
                                            this.showModalDelete(params.index)
                                        } else {
                                            this.$router.push({
                                                name: 'giroPaymentAdd',
                                                params: {
                                                    paymentGiroId: row.giroId,
                                                    paymentGiroDate: moment(row.giroDate, 'DD MMM YYYY').format("DD-MM-YYYY"),
                                                    paymentGiroAmount: parseInt(row.giroNominal.replace(/\D/g, "")),
                                                    paymentGiroMarking: row.marking,
                                                    paymentGiroMarkingGroup: row.markingGroup,
                                                    markingIdSelected: row.markingHeaderId ? row.markingHeaderId : row.markingGroupId,
                                                    isGroup: isGroup
                                                }
                                            });
                                        }
                                    }
                                }
                            }, title),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: setDisable
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.immediatelyCancel(params.index)
                                    }
                                }
                            }, 'Batalkan'),
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small',
                                    disabled: setDisableEdit
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalEdit(params.index)
                                    }
                                }
                            }, 'Edit'),
                            h('Button', {
                                props: {
                                    type: 'default',
                                    size: 'small',
                                    disabled: setDisableHistory
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalHistory(params.index)
                                    }
                                }
                            }, 'History'),
                            h('Button', {
                                props: {
                                    type: 'default',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalRefGiro(params.index)
                                    }
                                }
                            }, 'Ref Giro'),
                            h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small',
                                    // disabled: setDisableDetail
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalDetail(params.index)
                                    }
                                }
                            }, 'Detail'),
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: setDisableMutasi
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalMutasi(params.index, 'old', null)
                                    }
                                }
                            }, 'Mutasi'),
                        ])
                    }
                }
            ],
            receivableGiroData: [],
            isModalConfirm: false,
            isNeedConfirm: false,
            confirmDescription: '',
            confirmationMessage: null,
            varType: null,
            varValue: null,
            varIndex: null,
            isModalHistory: false,
            columnsHistory: [
                {
                    title: 'Pembuat',
                    key: 'createdBy',
                },
                {
                    title: 'Tanggal Ubah',
                    key: 'createdAt',
                },
                {
                    title: 'Tanggal Jatuh Tempo',
                    key: 'dueDate',
                },
                {
                    title: 'Keterangan',
                    key: 'notes',
                },
            ],
            dataHistory: [],
            isModalConfirmDetail: false,
            isNeedConfirmDetail: false,
            tempGiroDetail: [],
            confirmDescriptionDetail: '',

            isModalDetail: false,
            columnsDetail: [
                {
                    title: 'Nomor Giro',
                    key: 'giroNumber',
                },
                {
                    title: 'Nominal Giro',
                    key: 'giroNominal',
                },
                {
                    title: 'Tanggal Jatuh Tempo',
                    key: 'paymentDate',
                },
                {
                    title: 'File(s)',
                    key: 'filename',
                    align: 'center',
                    width: 280,
                    render: (h, params) => {
                      const { row, index } = params

                      return h('div', {
                        style: {
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                          alignItems: 'center'
                        }
                      }, [

                        /* ===== DOWNLOAD LINK ===== */
                        h('a', {
                          class: 'table-link',
                          on: {
                            click: () => {
                              row.isType === 'new'
                                ? this.downloadFile(row.filename)
                                : this.downloadFileOld(row.markingHeaderCode, row.filename)
                            }
                          }
                        }, row.filename),

                        /* ===== UPLOAD AREA ===== */
                        h('Upload', {
                          props: {
                            type: 'drag',
                            name: 'fileUploaded',
                            action: this.serverUrlUploadFile,
                            beforeUpload: (file) => this.handleBeforeChangeFile(file, row, index),
                          },
                          ref: 'upload'
                        }, [
                          h('div', {
                            class: 'custom-edit-upload'
                          }, [
                            h('Icon', {
                              props: {
                                type: 'ios-cloud-upload',
                                size: 20
                              },
                              style: {
                                color: '#3399ff'
                              }
                            }),
                            h('p', 'Edit File')
                          ])
                        ])
                      ])
                    }
                },
                {
                    title: 'Status',
                    key: 'cancelStatus',
                    render: (h, params) => {
                        const { row } = params

                        return h('span', {
                            style: {
                              color: 'orange'
                            }
                        }, row.cancelStatus)
                    }
                },
                {
                    title: '',
                    key: 'isCancel',
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        const setDisable = row.isCancel == 1 || row.isPayment
                        const setDisableMutasi = row.isPending == 1

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: setDisable
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                      row.isType == 'new' ?
                                        this.showModalConfirmDetail(row) : this.showModalConfirm('isCancel', true, row.indexList)
                                    }
                                }
                            }, 'Batalkan'),
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: setDisableMutasi
                                },
                                on: {
                                    click: () => {
                                      row.isType == 'new' ?
                                        this.showModalMutasi(row.indexList, row.isType, row) : this.showModalMutasi(row.indexList, row.isType, null)
                                    }
                                }
                            }, 'Mutasi'),
                        ])
                    }
                }
            ],
            dataDetail: [],
            totalGiroNominalDetail: 0,

            isModalAddGiro: false,
            optionMarkings: [],
            optionGroupMarkings: [],
            optionPendings: [],
            isLoadingGetMarking: false,
            // isForm: false,
            isGroupAdd: false,
            formAddGiro: {
                giroDate: '',
                bankAccountId: '',
                markingHeaderId: null,
                markingGroupId: null,
                giroNominal: 0,
                formDynamic: {
                    items: [
                        {
                            index: 1,
                            status: 1,
                            giroNumber: '',
                            giroNominal: '',
                            paymentDate: '',
                            imageUploaded: '',
                            pValue: 0, // handle start progress bar uploading
                            isProgress: false // handle show/hide progress bar uploading
                        }
                    ]
                },
            },
            isDetailForm: false,
            ruleValidateGiro: {
                giroDate: [
                    { required: true, type: 'date', message: 'Pilih Tanggal Terima Giro', trigger: 'change' }
                ],
                giroNumber: [
                    { required: true, message: 'Masukkan Nomor Giro', trigger: 'blur' }
                ],
                giroNominal: [
                    { required: true, message: 'Masukkan Nominal Giro', trigger: 'blur' }
                ],
                paymentDate: [
                    { required: true, type: 'date', message: 'Pilih Tanggal Jatuh Tempo', trigger: 'change' }
                ],
                // bankAccountId: [
                //     { required: true, message: 'Pilih Bank', trigger: 'change' }
                // ]
            },
            bankAccounts: [],
            isLoadingAddGiro: false,
            serverUrlUploadFile: "",
            isProgress: false,
            pValue: 0,

            isModalEdit: false,
            isModalRefGiro: false,
            isGroupEdit: false,
            formDetailGiro: {
                giroId: null,
                bankAccountId: null,
            },
            bankAccountIdEdit: null,
            formEditGiro: {
                markingHeaderId: null,
                markingGroupId: null,
                giroDate: '',
                giroNumber: '',
                giroNominal: '',
                paymentDate: '',
                bankAccountId: '',
                imageUploaded: ''
            },
            formRefGiro: {
                markingHeaderId: null,
                markingGroupId: null,
                giroNumber: '',
            },
            isLoadingEditdGiro: false,

            isModalDelete: false,
            formDeleteGiro: {
                giroId: null,
                paymentId: null,
                noteCode: ''
            },
            filename: `giro-list-` + Date.now(),
            htmlPdfOption: {
                filename: `giro-list-` + Date.now() + `.pdf`,
                margin: 5,
                jsPDF: {
                    format: 'a4',
                    orientation: 'l'
                }
            },

            isModalMutasi: false,
            isGroupMutasi: false,
            formMutasi: {
                markingHeaderId: null,
                markingGroupId: null,
                paymentDate: '',
                bankAccountId: '',
                noteCode: '',
                giroNominal: '',
                descriptionMutasi: ''
            },
            isLoadingMutasi: false,

            totalGiro: 0,
            totalNominal: 0
        }
    },
    methods: {
        rowClassName(row, index) {
            if (row.isCancel) {
                return 'demo-table-info-row';
            }

            return '';
        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getReceivableGiroList: function () {
            let parent = this;
            let startGiroDate = null;
            let endGiroDate = null;
            let startPaymentDate = null;
            let endPaymentDate = null;

            // set is group & null marking
            if (this.isGroupFilter) {
                this.markingHeaderIdSelected = null;
            }
            // set is marking & null group marking
            else {
                this.markingGroupIdSelected = null;
            }

            // handle giro date - tanggal terima giro
            if (this.giroDateSelected[0] != "" && this.giroDateSelected[0] != null) {
                startGiroDate = moment(this.giroDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endGiroDate = moment(this.giroDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            // handle payment date / tanggal jatuh tempo
            if (this.paymentDateSelected[0] != "" && this.paymentDateSelected[0] != null) {
                startPaymentDate = moment(this.paymentDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endPaymentDate = moment(this.paymentDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            let payload = {
                startGiroDate: startGiroDate,
                endGiroDate: endGiroDate,
                startPaymentDate: startPaymentDate,
                endPaymentDate: endPaymentDate,
                markingHeaderId: this.markingHeaderIdSelected,
                markingGroupId: this.markingGroupIdSelected,
                bankAccountId: this.bankAccountId,
                isCancel: false
            }
            console.log({ payload });

            // set default after add/edit
            this.pValue = 0;
            this.isProgress = false;

            this.isLoadingGiroList = true;
            this.receivableGiroData = [];
            HTTP.post('giro/search', payload)
                .then(response => {
                    let receivableGiro = []
                    console.log({ response });
                    // reset calculate total giro & total nominal
                    parent.totalGiro = 0
                    parent.totalNominal = 0

                    _.forEach(response.data, function (value, index) {
                        let receivableId = value.creditReceivableId
                        let paymentId = value.paymentId
                        let giroId = value.id
                        let giroDate = parent.showDateFormatted(value.giroDate)
                        let giroNumber = value.giroNumber
                        let giroNominal = "Rp. " + numeral(value.giroNominal).format('0,0')
                        let noteCode = value.noteCode
                        let paymentDate = parent.showDateFormatted(value.paymentDate)
                        let bankAccountId = value.bank_account != null ? value.bank_account.id : ''
                        let accountName = value.bank_account != null ? value.bank_account.accountName : ''
                        // let dueDate = parent.showDateFormatted(value.dueDate)
                        let dueDate = moment(value.dueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD")
                        let isClearing = value.isClearing
                        let isCancel = value.isCancel
                        let giroHistory = value.giro_history
                        let description = value.receivable != null ? value.receivable.description : ''
                        let partai = value.receivable != null ? value.receivable.invoice.packaging_list.container_loading.containercode : ''
                        let marking = value.marking_header != null ? value.marking_header.markingheadercode : '-'
                        let markingHeaderId = value.marking_header != null ? value.marking_header.markingheaderid : null
                        let markingGroup = value.marking_group != null ? value.marking_group.code : '-'
                        let markingGroupId = value.marking_group != null ? value.marking_group.id : null
                        let dueNotes = value.dueNotes
                        let cancelNotes = value.cancelNotes
                        let file = value.filename
                        let markingHeaderCode = null
                        let giroDetail = value.giro_detail
                        let isMutation = value.isMutation
                        let refGiroCode = value.refGiroCode

                        if (value.marking_header != null) {
                            markingHeaderCode = value.marking_header.markingheadercode
                        } else if (value.marking_group != null) {
                            markingHeaderCode = value.marking_group.code
                        }

                        if (giroDetail.length > 0) {
                          let giroNumberDetail = ''
                          let paymentDateDetail = ''

                          _.forEach(giroDetail, function (giro) {
                              giroNumberDetail += giro.giroNumber + '<br/>'
                              paymentDateDetail += parent.showDateFormatted(giro.paymentDate) + '<br/>'
                          });

                          giroNumber = giroNumberDetail
                          paymentDate = paymentDateDetail
                        }

                        let paymentAllocate = [{
                            invoicefee: value.receivable != null ? value.receivable.invoice.invoicefee : '',
                            invoiceDueId: value.invoice_due != null ? value.invoice_due.id : '',
                            allocateAmount: value.giroNominal,
                            receivableRemaining: value.invoice_due != null ? value.invoice_due.receivableRemaining : '',
                            useDepositAmount: 0,
                        }]

                        let clearingPaymentAdd = {
                            markingHeaderId: value.markingHeaderId,
                            amount: value.giroNominal,
                            transactionDate: moment(value.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            description: 'KU ' + accountName + ' P. ' + partai + ' - ' + description,
                            accountNumber: value.bank_account != null ? value.bank_account.id : '',
                            depositAmount: 0,
                            paymentAllocates: paymentAllocate,
                            depositType: '',
                            category: 'pay',
                            // paymentPendingId: null,
                            giroId: giroId
                        }

                        let rGiro = {
                            markingHeaderId: markingHeaderId,
                            markingGroupId: markingGroupId,
                            marking: marking,
                            markingGroup: markingGroup,
                            markingHeaderCode: markingHeaderCode,
                            receivableId: receivableId,
                            paymentId: paymentId,
                            giroId: giroId,
                            giroDate: giroDate,
                            giroNumber: giroNumber,
                            giroNominal: giroNominal,
                            noteCode: noteCode,
                            paymentDate: paymentDate,
                            bankAccountId: bankAccountId,
                            accountName: accountName,
                            dueDate: dueDate,
                            isClearing: isClearing,
                            isCancel: isCancel,
                            giroHistory: giroHistory,
                            clearingPaymentAdd: clearingPaymentAdd,
                            dueNotes: dueNotes,
                            cancelNotes: cancelNotes,
                            file: file,
                            giroDetail: giroDetail,
                            isMutation: isMutation,
                            refGiroCode: refGiroCode
                        }
                        receivableGiro.push(rGiro);

                        // calculate total giro & total nominal
                        parent.totalGiro++
                        parent.totalNominal += value.giroNominal
                    });

                    console.log({ receivableGiro });

                    this.receivableGiroData = receivableGiro;
                    this.isLoadingGiroList = false;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        downloadFile: function (fileName) {
          const payload = { file_name: fileName }

          HTTP
          .post('oss/giro-download', payload)
          .then(response => {
              console.log(response.data);

              const fileUrl = response.data.data.file_url
              window.open(fileUrl, '_blank');

              // const blob = new Blob([response.data]);
              // const url = window.URL.createObjectURL(blob);
              // const link = document.createElement('a');

              // link.href = url;
              // link.setAttribute('download', fileName);
              // document.body.appendChild(link);
              // link.click();
              // link.remove();
              // window.URL.revokeObjectURL(url);
          })
          .catch(e => {
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          })
        },
        downloadFileOld: function (markingHeaderCode, fileName) {
            let payload = {
                markingHeaderCode: markingHeaderCode,
                filename: fileName
            }

            HTTP
            .post('giro/file/download', payload, { responseType: 'blob' })
            .then(response => {
                console.log({ response });
                let a = document.createElement("a");
                let url = window.URL.createObjectURL(response.data);

                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd == false || this.isGroupFilter == false)) {
                    this.isLoadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.searchSelectSubbranch || null
                        })
                        .then(response => {
                            this.isLoadingGetMarking = false;
                            let data = response.data;

                            if (data.length > 0) {
                                const list = data.map(item => {
                                    return {
                                        value: item.markingheaderid,
                                        label: item.markingheadercode
                                    };
                                });

                                this.formAddGiro.markingHeaderCode = list[0].label;
                                this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGiroCode: _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd == false || this.isGroupFilter == false)) {
                    this.isLoadingGetMarking = true;
                    HTTP
                        .post('giro/note-codes', {
                            note_code: query
                        })
                        .then(response => {
                            this.isLoadingGetMarking = false;
                            let data = response.data.data;

                            if (data.length > 0) {
                                const list = data.map(item => {
                                    return {
                                        value: item.noteCode,
                                        label: item.noteCode
                                    };
                                });

                                this.noteCodes = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.noteCodes = [];
                }
            }, 300
        ),
        getEditMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '') {
                    this.formEditGiro.markingHeaderId = this.formEditGiro.markingSelectedId
                    this.isLoadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.searchSelectSubbranch || null,
                        })
                        .then(response => {
                            this.isLoadingGetMarking = false;
                            let data = response.data;

                            if (data.length > 0) {
                                const list = data.map(item => {
                                    return {
                                        value: item.markingheaderid,
                                        label: item.markingheadercode
                                    };
                                });

                                this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getPaymentPendingByFilter: _.debounce(
            function (query) {
                if (query && query !== '' && query.length >= 2) {
                    this.optionPendings = []
                    this.loadingSearch = true;

                    let urlFindByFilter = 'paymentPending/findByFilter';

                    HTTP
                        .post(urlFindByFilter, {
                            notes: query
                        })
                        .then(response => {
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.id,
                                    label: item.transactionDate + ', ' + item.notes + ' - ' + "Rp. " + numeral(item.balance).format('0,0')
                                };
                            });

                            this.optionPendings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);


                            this.loadingSearch = false;
                        })
                        .catch(e => {
                            this.loadingSearch = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                }
            }),
        getGroupMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && (this.isGroupAdd || this.isGroupFilter)) {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('markingGroup/getByCode', {
                            groupName: query
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            if (data.length > 0) {
                                const list = data.map(item => {
                                    return {
                                        value: item.id,
                                        label: item.code
                                    };
                                });

                                this.formAddGiro.markingHeaderCode = list[0].label;
                                this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        getEditGroupMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '') {
                    this.formEditGiro.markingGroupId = this.formEditGiro.markingGroupSelectedId
                    this.loadingGetMarking = true;
                    HTTP
                        .post('markingGroup/getByCode', {
                            groupName: query
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            if (data.length > 0) {
                                const list = data.map(item => {
                                    return {
                                        value: item.id,
                                        label: item.code
                                    };
                                });

                                this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),

        getBankAccount: function () {
            HTTP.get("bankAccount/findAll/active")
                .then(response => {
                    this.bankAccounts = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        showAddGiro: function () {
            this.isModalAddGiro = true;
        },
        isHeaderFilled: function() {
          let fGiroDate = this.formAddGiro.giroDate;
          let fBankAccountId = this.formAddGiro.bankAccountId;
          let fMarkingHeaderId = this.formAddGiro.markingHeaderId;
          let fMarkingGroupId = this.formAddGiro.markingGroupId;

          if(
            (fGiroDate != '' && fGiroDate != null) &&
            (fBankAccountId != '' && fBankAccountId != undefined) &&
            (
              (fMarkingHeaderId != '' && fMarkingHeaderId != undefined) ||
              (fMarkingGroupId != '' && fMarkingGroupId != undefined)
            )
          ) {
            this.isDetailForm = true
          }else {
            this.isDetailForm = false
          }
        },
        handleAdd() {
            this.formAddGiro.index++;
            this.formAddGiro.formDynamic.items.push({
                index: this.formAddGiro.index,
                status: 1,
                giroNumber: '',
                giroNominal: '',
                paymentDate: '',
                imageUploaded: '',
                pValue: 0, // handle start progress bar uploading
                isProgress: false // handle show/hide progress bar uploading
            });
        },
        handleRemove(index) {
            const payload = { file_name: this.formAddGiro.formDynamic.items[index].imageUploaded }

            if (payload.file_name != '') {
                HTTP
                .post('oss/giro-delete', payload)
                .then(response => {
                    console.log({response});

                    this.$Notice.success({ title: "File berhasil di hapus !" });
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            } else {
                this.formAddGiro.formDynamic.items[index].status = 0;
            }
        },
        handleBeforeUpload(file, index) {
            const timestamp = Date.now();
            const extension = file.name.split('.').pop();
            const newFileName = `GIRO-${timestamp}.${extension}`;
            const renamedFile = new File([file], newFileName, { type: file.type });

            const formData = new FormData();
            formData.append('file', renamedFile);
            // formData.append('markingHeaderCode', this.formAddGiro.markingHeaderCode);

            this.formAddGiro.formDynamic.items[index].isProgress = true;
            this.formAddGiro.formDynamic.items[index].pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

            HTTP
            .post('oss/giro-upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(response => {
                // this.formAddGiro.filename = response.data.filename; // Set filename
                // this.formEditGiro.filename = response.data.filename; // Set filename
                // this.formAddGiro.imageUploaded = response.data.url;
                // this.formEditGiro.imageUploaded = response.data.url;
                // this.isProgress = false;

                console.log({response});

                this.formAddGiro.formDynamic.items[index].imageUploaded = response.data.file_name; // Set filename
                this.$Notice.success({ title: "File berhasil di upload !" });
                this.formAddGiro.formDynamic.items[index].pValue = 100;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },
        handleDownload(index) {
            const payload = { file_name: this.formAddGiro.formDynamic.items[index].imageUploaded }

            HTTP
            .post('oss/giro-download', payload)
            .then(response => {
                console.log({response});

                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        handleBeforeChangeFile(file, row, index) {
            const timestamp = Date.now();
            const extension = file.name.split('.').pop();
            const newFileName = `GIRO-${timestamp}.${extension}`;
            const renamedFile = new File([file], newFileName, { type: file.type });

            const formData = new FormData();
            formData.append('file', renamedFile);
            formData.append('giroDetailId', row.id);

            HTTP
            .post('oss/giro-upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(response => {
                console.log({response});

                this.$set(this.dataDetail[index], 'filename', response.data.file_name); // Set filename
                this.$Notice.success({ title: "File berhasil di upload !" });
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },
        postAddGiro: function () {
            this.isLoadingAddGiro = true;
            this.$Loading.start();

            let giroDetails = [];

            _.forEach(this.formAddGiro.formDynamic.items, function (value, index) {

                if (value.status) {
                    let giro = {
                        giroNumber: value.giroNumber,
                        giroNominal: value.giroNominal,
                        paymentDate: moment(value.paymentDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                        filename: value.imageUploaded
                    }

                    giroDetails.push(giro);
                }
            });

            let payload = {
                giroDate: moment(this.formAddGiro.giroDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                bankAccountId: this.formAddGiro.bankAccountId,
                markingHeaderId: this.formAddGiro.markingHeaderId,
                markingGroupId: this.formAddGiro.markingGroupId,
                noteCode: this.formAddGiro.noteCode,
                giroNominal: this.totalGiroNominal,
                giroDetails: giroDetails
            }

            console.log({ payload });
            // return false;

            HTTP
                .post('giro/create', payload)
                .then(response => {
                    console.log("post response :", response);

                    this.isModalAddGiro = false;
                    this.isLoadingAddGiro = false;
                    this.$Loading.finish();
                    this.$Message.success('Giro berhasil ditambahkan !');

                    this.$Notice.warning({
                        title: "Warning",
                        desc: "Giro " + response.data.data.noteCode + " Berhasil dibuat",
                        duration: 7
                    })

                    // this.getReceivableGiroList(); // update list
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showModalConfirm: function (type, value, index) {
            this.isModalConfirm = true
            this.varType = type
            this.varValue = value
            this.varIndex = index

            if (type == 'isDueDate') {
                this.confirmationMessage = 'Apakah anda yakin ingin mengubah tanggal mundur?'
                this.isNeedConfirm = true
            } else if (type == 'isClearing') {
                this.confirmationMessage = 'Apakah anda yakin ingin meng-kliring giro ?'
            } else if (type == 'isCancel') {
                this.confirmationMessage = 'Apakah anda yakin ingin membatalkan giro ?'
                this.isNeedConfirm = true
            } else {
                return false
            }
        },
        updateGiroList: function () {
            this.$Loading.start();

            let rowData = this.receivableGiroData[this.varIndex]
            let tempIsDueDate = ''
            let tempIsClearing = ''
            let tempIsCancel = ''
            let successMsg = ''
            let dueNotes = rowData.dueNotes
            let cancelNotes = rowData.cancelNotes

            console.log({ rowData });
            // return false

            if (this.varType == 'isDueDate') {
                tempIsDueDate = this.varValue
                tempIsClearing = rowData.isClearing
                tempIsCancel = rowData.isCancel
                dueNotes = this.confirmDescription
                successMsg = 'Tanggal mundur berhasil diperbaharui !'
            } else if (this.varType == 'isClearing') {
                // Checklist = add payment
                // Unchecklist = delete payment
                // Update pembayaran terlebih dahulu
                // if (this.varValue) {
                //     HTTP
                //     .post('payment/pay', rowData.clearingPaymentAdd)
                //     .then(response => {
                //         this.$Message.success({
                //             content: 'Pembayaran telah ditambahkan !',
                //             duration: 2
                //         });
                //     })
                //     .catch(e => {
                //         this.$Notice.error({
                //             title: "Error",
                //             desc: e,
                //             duration: 5
                //         });

                //         return false
                //     })
                // } else {
                //     HTTP
                //     .post('payment/delete', {
                //         paymentId: rowData.paymentId,
                //         receivableId: rowData.receivableId
                //     })
                //     .then(response => {
                //         this.$Message.success({
                //             content: 'Pembayaran telah dihapus !',
                //             duration: 2
                //         });
                //     })
                //     .catch(e => {
                //         this.$Notice.error({
                //             title: "Error",
                //             desc: e,
                //             duration: 5
                //         });

                //         return false
                //     })
                // }

                tempIsDueDate = rowData.dueDate
                tempIsClearing = this.varValue
                tempIsCancel = rowData.isCancel
                successMsg = 'Giro berhasil dikliring !'
            } else if (this.varType == 'isCancel') {
                tempIsDueDate = rowData.dueDate
                tempIsClearing = rowData.isClearing
                tempIsCancel = this.varValue
                cancelNotes = this.confirmDescription
                successMsg = 'Giro berhasil dibatalkan !'
            } else {
                return false
            }

            let payload = {
                giroId: rowData.giroId,
                dueDate: moment(tempIsDueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                isClearing: tempIsClearing,
                isCancel: tempIsCancel,
                dueNotes: dueNotes,
                cancelNotes: cancelNotes
            }

            console.log({ payload });

            HTTP
                .post('giro/update', payload)
                .then(response => {
                    this.confirmDescription = '';
                    this.isModalConfirm = false;
                    this.isNeedConfirm = false;
                    this.$Loading.finish();
                    this.$Message.success(successMsg);
                    this.getReceivableGiroList(this.paymentDateSelected);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        updateDetailData: function () {
            this.$Loading.start();
            let payload = {
                giroId: this.formDetailGiro.giroId,
                bankAccountId: this.formDetailGiro.bankAccountId,
                isDetail: true,
            }

            HTTP
              .post('giro/update', payload)
              .then(response => {
                  this.isModalDetail = false;
                  this.$Loading.finish();

                  this.$Message.success("Giro detail berhasil diperbaharui !");
                  this.getReceivableGiroList(this.paymentDateSelected);
              })
              .catch(e => {
                  this.$Notice.error({
                      title: "Error",
                      desc: e,
                      duration: 5
                  });
              })
        },
        cancelUpdateGiroList: function () {
            this.getReceivableGiroList(this.paymentDateSelected);
            this.confirmDescription = '';
            this.isModalConfirm = false;
            this.isNeedConfirm = false;
        },
        showModalHistory: function (index) {
            this.isModalHistory = true
            let parent = this
            let rowData = this.receivableGiroData[index]
            let histories = []

            _.forEach(rowData.giroHistory, function (value, index) {
                let createdBy = value.createdBy
                let createdAt = value.createdAt
                let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : '-'
                let notes = value.notes

                let history = {
                    createdBy: createdBy,
                    createdAt: createdAt,
                    dueDate: dueDate,
                    notes: notes,
                }
                histories.push(history);
            });

            this.dataHistory = histories;
        },
        immediatelyCancel: function (index) {
            let parent = this
            let rowData = this.receivableGiroData[index]
            let details = []

            if (rowData.giroDetail.length > 0) {
              let data = rowData.giroDetail;
              let temptTotalGND = 0;

              _.forEach(data, function (value) {
                  let isCancel = value.isCancel
                  temptTotalGND += isCancel ? 0 : value.giroNominal

                  let paymentDate = (value.paymentDate != null && value.paymentDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.paymentDate) : '-'
                  let detail = {
                      id: value.id,
                      giroId: value.giroId,
                      giroNumber: value.giroNumber,
                      giroNominal: "Rp. " + numeral(value.giroNominal).format('0,0'),
                      paymentDate: paymentDate,
                      filename: value.filename,
                      cancelStatus: value.isCancel ? 'Dibatalkan' : '-',
                      isType: 'new', // flagging data baru (multiple giro)
                      isPayment: rowData.paymentId != null ? true : false,
                      isCancel: isCancel,
                  }
                  details.push(detail);
              });

              parent.totalGiroNominalDetail = "Rp. " + numeral(temptTotalGND).format('0,0')
            } else { // ini untuk nghandle data lama (sebelum multiple)
                let detail = {
                    giroNumber: rowData.giroNumber,
                    giroNominal: rowData.giroNominal,
                    paymentDate: rowData.paymentDate,
                    filename: rowData.file,
                    cancelStatus: rowData.isCancel ? 'Dibatalkan' : '-',
                    isType: 'old', // flagging data lama (sebelum multiple giro)
                    isPayment: rowData.paymentId != null ? true : false,
                    markingHeaderCode: rowData.markingHeaderCode,
                    indexList: index // khusus untuk cancel data lama
                }
                details.push(detail);

                parent.totalGiroNominalDetail = rowData.giroNominal
            }

            this.showModalConfirmDetail(details);
        },
        showModalDetail: function (index) {
            this.isModalDetail = true
            this.totalGiroNominalDetail = 0

            let parent = this
            let rowData = this.receivableGiroData[index]
            let details = []

            console.log({rowData})
            console.log({index})

            if (rowData.giroDetail.length > 0) {
              let data = rowData.giroDetail;
              let temptTotalGND = 0;

              this.formDetailGiro.giroId = rowData.giroId;
              this.formDetailGiro.bankAccountId = rowData.bankAccountId;

              console.log("data detail :", this.formDetailGiro);


              // cek data isCancel (allCancelled) -> update ke history pembatalan giro
              // let allCancelled = data.every(item => item.isCancel === 1);

              _.forEach(data, function (value) {
                  let isCancel = value.isCancel
                  let isPending = value.isPending
                  temptTotalGND += isCancel ? 0 : value.giroNominal

                  let paymentDate = (value.paymentDate != null && value.paymentDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.paymentDate) : '-'
                  let detail = {
                      id: value.id,
                      giroId: value.giroId,
                      giroNumber: value.giroNumber,
                      giroNominal: "Rp. " + numeral(value.giroNominal).format('0,0'),
                      paymentDate: paymentDate,
                      filename: value.filename,
                      cancelStatus: value.isCancel ? 'Dibatalkan' : '-',
                      isType: 'new', // flagging data baru (multiple giro)
                      isPayment: rowData.paymentId != null ? true : false,
                      isCancel: isCancel,
                      isPending: isPending,
                      // allCancelled: allCancelled,
                      indexList: index // untuk get rowListHeader
                  }
                  details.push(detail);
              });

              parent.totalGiroNominalDetail = "Rp. " + numeral(temptTotalGND).format('0,0')
            } else { // ini untuk nghandle data lama (sebelum multiple)
                let detail = {
                    giroNumber: rowData.giroNumber,
                    giroNominal: rowData.giroNominal,
                    paymentDate: rowData.paymentDate,
                    filename: rowData.file,
                    cancelStatus: rowData.isCancel ? 'Dibatalkan' : '-',
                    isType: 'old', // flagging data lama (sebelum multiple giro)
                    isPayment: rowData.paymentId != null ? true : false,
                    markingHeaderCode: rowData.markingHeaderCode,
                    indexList: index // khusus untuk cancel data lama
                }
                details.push(detail);

                parent.totalGiroNominalDetail = rowData.giroNominal
            }

            this.dataDetail = details;
        },
        showModalConfirmDetail: function (giroDetail) {
            this.isModalConfirmDetail = true
            this.isNeedConfirmDetail = true
            this.tempGiroDetail = giroDetail
        },
        cancelUpdateGiroDetail: function () {
            this.confirmDescriptionDetail = '';
            this.isModalConfirmDetail = false;
            this.isNeedConfirmDetail = false;
        },
        parseUnformat(rupiah) {
          // hapus format rupiah
          return Number(rupiah.replace(/[Rp.\s,]/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'));
        },
        updateGiroDetail: function () {
            this.$Loading.start();
            let giroDetail = this.tempGiroDetail

            if (giroDetail.length >= 1) {
                const promises = giroDetail.map(item => {
                  let payload = {
                    id: item.id,
                    giroId: item.giroId,
                    isCancel: true,
                    cancelNotes: this.confirmDescriptionDetail,
                    totalGiro: 0,
                  };

                  console.log({ payload });

                  return HTTP.post('giro/update-detail', payload);
                });

                Promise.all(promises)
                .then(() => {
                  this.confirmDescriptionDetail = '';
                  this.isModalConfirmDetail = false;
                  this.isNeedConfirmDetail = false;
                  this.isModalDetail = false;
                  this.$Loading.finish();
                  this.$Message.success('Giro berhasil dibatalkan !');
                  this.getReceivableGiroList(this.paymentDateSelected);
                })
                .catch(e => {
                  this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                  });
                });
            } else {
                let tempTotalGiro = this.parseUnformat(this.totalGiroNominalDetail);
                let tempGiroNominal = this.parseUnformat(giroDetail.giroNominal);

                let payload = {
                  id: giroDetail.id,
                  giroId: giroDetail.giroId,
                  isCancel: true,
                  cancelNotes: this.confirmDescriptionDetail,
                  totalGiro: tempTotalGiro - tempGiroNominal,
                };

                console.log({ payload });

                HTTP.post('giro/update-detail', payload)
                .then(() => {
                  this.confirmDescriptionDetail = '';
                  this.isModalConfirmDetail = false;
                  this.isNeedConfirmDetail = false;
                  this.isModalDetail = false;
                  this.$Loading.finish();
                  this.$Message.success('Giro berhasil dibatalkan !');
                  this.getReceivableGiroList(this.paymentDateSelected);
                })
                .catch(e => {
                  this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                  });
                });
            }
        },
        showModalEdit: function (index) {
            let rowData = this.receivableGiroData[index];

            console.log({ rowData });
            if (rowData.markingHeaderId) {
                this.isGroupEdit = false
                this.getEditMarkingByCode(rowData.marking)
            }

            if (rowData.markingGroupId) {
                this.isGroupEdit = true
                this.getEditGroupMarkingByCode(rowData.markingGroup)
            }

            this.formEditGiro.giroId = rowData.giroId;
            this.formEditGiro.markingSelectedId = rowData.markingHeaderId;
            this.formEditGiro.markingGroupSelectedId = rowData.markingGroupId;

            this.formEditGiro.markingHeaderId = rowData.markingHeaderId;
            this.formEditGiro.markingGroupId = rowData.markingGroupId;
            this.formEditGiro.giroDate = moment(rowData.giroDate, "DD MMM YYYY").format("YYYY-MM-DD");
            this.formEditGiro.giroNumber = rowData.giroNumber;
            this.formEditGiro.giroNominal = rowData.giroNominal;
            this.formEditGiro.paymentDate = moment(rowData.paymentDate, "DD MMM YYYY").format("YYYY-MM-DD");
            this.formEditGiro.bankAccountId = rowData.bankAccountId;

            this.isModalEdit = true;
        },
        showModalRefGiro: function (index) {
          let rowData = this.receivableGiroData[index];

            console.log({ rowData });
            if (rowData.markingHeaderId) {
                this.isGroupEdit = false
                this.getEditMarkingByCode(rowData.marking)
            }

            if (rowData.markingGroupId) {
                this.isGroupEdit = true
                this.getEditGroupMarkingByCode(rowData.markingGroup)
            }

            this.formRefGiro.giroId = rowData.giroId;
            this.formRefGiro.markingSelectedId = rowData.markingHeaderId;
            this.formRefGiro.markingGroupSelectedId = rowData.markingGroupId;

            this.formRefGiro.markingHeaderId = rowData.markingHeaderId;
            this.formRefGiro.markingGroupId = rowData.markingGroupId;

            this.isModalRefGiro = true;
        },
        postUpdateGiro: function () {
            this.isLoadingAddGiro = true;
            this.$Loading.start();

            let payload = {
                giroId: this.formEditGiro.giroId,
                markingHeaderId: this.formEditGiro.markingHeaderId,
                markingGroupId: this.formEditGiro.markingGroupId,
                giroDate: moment(this.formEditGiro.giroDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                giroNumber: this.formEditGiro.giroNumber,
                giroNominal: this.formEditGiro.giroNominal,
                paymentDate: moment(this.formEditGiro.paymentDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                bankAccountId: this.formEditGiro.bankAccountId,
                filename: this.formEditGiro.filename
            }

            console.log({ payload });
            // return false;

            HTTP
                .post('giro/update', payload)
                .then(response => {
                    console.log("post update response :", response);

                    this.isModalEdit = false;
                    this.isLoadingAddGiro = false;
                    this.$Loading.finish();
                    this.$Message.success('Giro berhasil diubah !');
                    this.getReceivableGiroList(this.paymentDateSelected);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        postUpdateRefGiro: function () {
            this.isLoadingAddGiro = true;
            this.$Loading.start();

            let payload = {
                giroId: this.formRefGiro.giroId,
                noteCode: this.formRefGiro.giroNumber,
            }

            console.log({ payload });

            HTTP
                .post('giro/update-ref-giro', payload)
                .then(response => {
                    console.log("post update response :", response);

                    this.isModalEdit = false;
                    this.isLoadingAddGiro = false;
                    this.$Loading.finish();
                    this.$Message.success('Giro berhasil diubah !');
                    this.getReceivableGiroList(this.paymentDateSelected);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showModalDelete: function (index) {
            let rowData = this.receivableGiroData[index];

            console.log({ rowData });

            this.formDeleteGiro.giroId = rowData.giroId;
            this.formDeleteGiro.paymentId = rowData.paymentId;
            this.formDeleteGiro.noteCode = rowData.noteCode;

            this.isModalDelete = true;
        },
        deleteGiroPayment: function () {
            this.$Loading.start();

            let payload = {
                giroId: this.formDeleteGiro.giroId,
                paymentId: this.formDeleteGiro.paymentId,
            }

            console.log({ payload });

            HTTP
                .post('giro/payment/delete', payload)
                .then(response => {
                    console.log("post delete response :", response);

                    if (response.data.data == true) {
                        this.isModalDelete = false;
                        this.$Loading.finish();
                        this.$Message.success('Pembayaran giro berhasil dihapus !');
                    } else {
                        this.isModalDelete = false;
                        this.$Loading.finish();
                        this.$Message.error('Pembayaran giro gagal dihapus !');
                    }

                    this.getReceivableGiroList();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showModalMutasi: function (indexHeader, type, data) {
            let rowDataHeader = this.receivableGiroData[indexHeader];
            console.log({rowDataHeader});
            console.log({data});

            if (type == 'new' && rowDataHeader.giroDetail.length > 0) {
                if (rowDataHeader.markingHeaderId) {
                    this.isGroupMutasi = false
                    this.getEditMarkingByCode(rowDataHeader.marking)
                }

                if (rowDataHeader.markingGroupId) {
                    this.isGroupMutasi = true
                    this.getEditGroupMarkingByCode(rowDataHeader.markingGroup)
                }

                this.formMutasi.markingSelectedId = rowDataHeader.markingHeaderId;
                this.formMutasi.markingGroupSelectedId = rowDataHeader.markingGroupId;
                this.formMutasi.markingHeaderId = rowDataHeader.markingHeaderId;
                this.formMutasi.markingGroupId = rowDataHeader.markingGroupId;
                this.formMutasi.bankAccountId = rowDataHeader.bankAccountId;
                this.formMutasi.noteCode = rowDataHeader.noteCode;

                this.formMutasi.giroId = data.giroId;
                this.formMutasi.giroDetailId = data.id;
                this.formMutasi.dueDate = moment(data.paymentDate, "DD MMM YYYY").format("YYYY-MM-DD");
                this.formMutasi.paymentDate = moment(data.paymentDate, "DD MMM YYYY").format("YYYY-MM-DD");
                this.formMutasi.giroNominal = data.giroNominal;
            } else {
                if (rowDataHeader.markingHeaderId) {
                  this.isGroupMutasi = false
                    this.getEditMarkingByCode(rowDataHeader.marking)
                }

                if (rowDataHeader.markingGroupId) {
                    this.isGroupMutasi = true
                    this.getEditGroupMarkingByCode(rowDataHeader.markingGroup)
                }

                this.formMutasi.giroId = rowDataHeader.giroId;
                this.formMutasi.giroDetailId = null;
                this.formMutasi.markingSelectedId = rowDataHeader.markingHeaderId;
                this.formMutasi.markingGroupSelectedId = rowDataHeader.markingGroupId;

                this.formMutasi.markingHeaderId = rowDataHeader.markingHeaderId;
                this.formMutasi.markingGroupId = rowDataHeader.markingGroupId;
                this.formMutasi.dueDate = moment(rowDataHeader.paymentDate, "DD MMM YYYY").format("YYYY-MM-DD");
                this.formMutasi.paymentDate = moment(rowDataHeader.paymentDate, "DD MMM YYYY").format("YYYY-MM-DD");
                this.formMutasi.bankAccountId = rowDataHeader.bankAccountId;
                this.formMutasi.noteCode = rowDataHeader.noteCode;
                this.formMutasi.giroNominal = rowDataHeader.giroNominal;
            }

            console.log('this.formMutasi : ', this.formMutasi);


            this.isModalMutasi = true;
        },
        cancelAddMutasi: function () {
            this.formMutasi.markingSelectedId = '';
            this.formMutasi.markingGroupSelectedId = '';
            this.formMutasi.markingHeaderId = '';
            this.formMutasi.markingGroupId = '';
            this.formMutasi.giroId = '';
            this.formMutasi.giroDetailId = '';
            this.formMutasi.paymentDate = '';
            this.formMutasi.bankAccountId = '';
            this.formMutasi.noteCode = '';
            this.formMutasi.giroNominal = '';
            this.formMutasi.descriptionMutasi = '';
        },
        postAddMutasi: function () {
            this.isLoadingMutasi = true;
            this.$Loading.start();

            let payload = {
                giroId: this.formMutasi.giroId,
                giroDetailId: this.formMutasi.giroDetailId,
                markingHeaderId: this.formMutasi.markingHeaderId,
                markingGroupId: this.formMutasi.markingGroupId,
                paymentDate: moment(this.formMutasi.paymentDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                bankAccountId: this.formMutasi.bankAccountId,
                noteCode: this.formMutasi.noteCode,
                giroNominal: this.formMutasi.giroNominal,
                descriptionMutasi: this.formMutasi.descriptionMutasi,
            }

            console.log({ payload });
            // return false;

            HTTP
                .post('giro/create/mutasi', payload)
                .then(response => {
                    console.log("add mutasi response :", response);

                    this.isModalMutasi = false;
                    this.isLoadingMutasi = false;
                    this.isModalDetail = false;
                    this.$Loading.finish();
                    this.$Message.success('Giro mutasi berhasil ditambahkan !');

                    this.formMutasi.markingSelectedId = '';
                    this.formMutasi.markingGroupSelectedId = '';
                    this.formMutasi.markingHeaderId = '';
                    this.formMutasi.markingGroupId = '';
                    this.formMutasi.giroId = '';
                    this.formMutasi.giroDetailId = '';
                    this.formMutasi.paymentDate = '';
                    this.formMutasi.bankAccountId = '';
                    this.formMutasi.noteCode = '';
                    this.formMutasi.giroNominal = '';
                    this.formMutasi.descriptionMutasi = '';
                    this.getReceivableGiroList(this.paymentDateSelected);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },

        generateReport() {
            this.$refs.html2Pdf.generatePdf()
        },

        generateExcel: function () {
            var listGiroData = _.map(this.receivableGiroData, obj => _.pick(obj, ['marking', 'markingGroup', 'giroDate', 'paymentDate', 'giroNumber', 'giroNominal', 'accountName', 'dueDate', 'isClearing', 'dueNotes', 'cancelNotes']))
            const data = XLSX.utils.json_to_sheet(listGiroData)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, data, 'List giro')

            XLSX.utils.sheet_add_aoa(data, [['Marking', 'Marking Group', 'Tgl. Terima Giro', 'Tgl. Jatuh Tempo', 'Nomor Giro', 'Nominal Giro', 'Bank', 'Tgl. Mundur', 'Kliring', 'Keterangan Tgl. Mundur', 'Keterangan Pembatalan']])

            XLSX.writeFile(wb, this.filename + '.xlsx')
        }
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    mounted() {
        // this.getReceivableGiroList()
        this.$Loading.config({
            color: '#fff',
            failedColor: '#f0ad4e',
            height: 10
        });

        this.getBankAccount();
    },
    computed: {
      totalGiroNominal() {
        return this.formAddGiro.formDynamic.items.reduce((total, item) => {
          return total + Number(item.giroNominal || 0);
        }, 0);
      }
    }
}

</script>



// WEBPACK FOOTER //
// GiroList.vue?b5f7e5de